import * as React from "react";
import { useState, useEffect } from "react";
import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { activate } from "../services/AuctionService";
import { IBestOffer } from "../models/offer";
import { IProfile, IProfileRole } from "../models/profile";

import { useNavigate, useSearchParams } from 'react-router-dom';

export const Activate = () => {  
  const navigate = useNavigate(); 
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");

  useEffect(() => {
    const p: string = searchParams.get('p') || '';
    console.log('Activation parameter p:', p);
    activate(p).then(res => {
      console.log(res);
      if(res.Success) {        
        setTimeout(() => {
          navigate('/login');
        }, 5000);
      } else {
        setMessage(res.Message);
      }
    });
  }, []);
  
  return (
     <div className="container">
      <div className="page-title">ATTIVAZIONE UTENTE</div>
      <div>
        {message && <MessageBar key="error" intent="error">
            <MessageBarBody>
              <MessageBarTitle>Errore:</MessageBarTitle>{message}
            </MessageBarBody>
          </MessageBar>}
        {!message && <MessageBar key="success" intent="success">
            <MessageBarBody>
              <MessageBarTitle></MessageBarTitle>Utente attivato con successo. Effettua l'accesso.
            </MessageBarBody>
          </MessageBar>}          
      </div>
    </div>
  );
};